import forms from '@/mixins/forms.js';
import dates from '@/mixins/dates.js';
import { DateTime } from 'luxon';
export default {
    mixins: [dates, forms],
    data() {
        return {
            cargando: false,
            paciente: {
                id: null,
                id_pac: null,
                nombre_pac: null,
                ape_pat_pac: null,
                ape_mat_pac: null,
                sexo_pac: null,
                fecha_nac_pac: null,
                lugar_nac_pac: null,
                rfc_pac: null,
                curp_pac: null,
                tel_pac: null,
                cel_pac: null,
                id_edo_pac: '08',
                id_mpio_pac: null,
                calle_pac: null,
                num_ext_pac: null,
                num_int_pac: null,
                colonia_pac: null,
                cp_pac: null,
                ser_medico_pac: null,
                email_pac: null,
            },
            errors: {
                nombre_pac: null,
                ape_pat_pac: null,
                ape_mat_pac: null,
                sexo_pac: null,
                fecha_nac_pac: null,
                id_edo_pac: null,
                id_mpio_pac: null,
                calle_pac: null,
                num_ext_pac: null,
                colonia_pac: null,
                colonia_pac: null,
                cel_pac: null,
            },
            optionsSerMed: [{
                text: 'IMSS',
                value: 'imss'
            },
            {
                text: 'INSABI / Seguro Popular',
                value: 'insabi'
            },
            {
                text: 'ISSSTE',
                value: 'issste'
            },
            {
                text: 'Pensiones',
                value: 'pensiones'
            },
            {
                text: 'SEDENA',
                value: 'sedena'
            },
            {
                text: 'Ninguno',
                value: 'ninguno'
            },
            {
                text: 'Otro',
                value: 'otro'
            },
            ],
            edad: 0
        }
    },
    methods: {
        _getPac(a) {
            this.cargando = true;
            this._getThings('pacientes/' + a, 'paciente')
        },
        _preSavePac() {
            if (this._validateAll('paciente') && this._revisarFecha()) {
                const data = { paciente: this.paciente }
                this.paciente.id ?
                    this._updateAll('pacientes/' + this.paciente.id, data, 'msg', '_handlePacienteResponse') :
                    this._saveAll('pacientes', data, 'id', '_handlePacienteResponse');
            } else {
                this.$emit('msg', this.$lleneCampos)
            }
        },
        _handlePacienteResponse(res) {
            if ('id' in res) {
                this.paciente.id = res.id
                this.paciente.id_pac = res.id_pac
            }
            if (this.$route.name === 'PacientesForm')
                this.showDialogAcciones = true;

            this.$emit('msg', res.msg)
        },
        _revisarFecha() {
            if (DateTime.fromSQL(this._fromDmyToYmd(this.paciente.fecha_nac_pac)).isValid) {
                this.errors.fecha_nac_pac = null;
                return true;
            } else {
                let msg = 'Ingresa una fecha válida'
                this.errors.fecha_nac_pac = msg
                this.$emit('msg', msg)
            }
            return this.errors.fecha_nac_pac ? false : true
            // return false;
        },
        _calcAge(fecha) {
            this.edad =
                this._doEdad(this._fromDmyToYmd(fecha ? fecha : this.paciente.fecha_nac_pac))
        }
    },
    watch: {
        paciente(a) {
            if (a && a.id) {
                this.paciente.fecha_nac_pac = DateTime.fromSQL(a.fecha_nac_pac).toFormat('dd-MM-yyyy')
            }
        }
    }
}